module.exports = __webpack_public_path__ + "img/yellow.97f63a46.png";